import React__default from 'react';
import styled from 'styled-components';
import { Badge } from '../badge/Badge.js';
import { HappyWebSystemError } from '../base/SystemComponent.js';
import { Button } from '../button/Button.js';
import { COLOR_PALETTE } from '../colors/colorPalette.js';
import { Icon } from '../icon/Icon.js';
import { SearchInput } from '../inputs/SearchInput.js';

const Divider = styled.div`
  height: 1.5rem;
  border-right: 1px solid ${COLOR_PALETTE.slateGrey20};
`;
const StyledButton = styled(Button)`
  height: 2rem;
  border-radius: 0.25rem;
  padding: 0rem 1rem;
  min-width: 0.75rem;

  & > [${Icon.dataId}] {
    font-size: 1rem;
    height: 1.5rem;
    width: 1.25rem;
  }
`;
/**
 * 'Search' styled Filter.
 */ const SearchFilter = ({ filterCount =0 , throttleMS =1000 , onClick , onClear , testId ="X" , ...props })=>{
    if (onClick !== undefined && onClear === undefined || onClick === undefined && onClear !== undefined) {
        throw new HappyWebSystemError("SearchFilter", "When filters are being used, handlers must be provided for onClick and onClear");
    }
    return React__default.createElement(SearchInput, {
        "data-hpy-web-search-filter": true,
        testId: "SearchFilter-" + testId,
        ...props,
        throttleMS: throttleMS
    }, filterCount > 0 && React__default.createElement(React__default.Fragment, null, React__default.createElement(StyledButton, {
        testId: "SearchFilter-Clear-" + testId,
        variant: "default-inverse",
        disabled: props.disabled || props.readOnly,
        onClick: onClear
    }, "Clear All"), React__default.createElement(Divider, null)), onClick !== undefined && React__default.createElement(StyledButton, {
        testId: "SearchFilter-AddFilters-" + testId,
        variant: "context-inverse",
        icon: filterCount <= 0 ? "filter" : undefined,
        disabled: props.disabled || props.readOnly,
        onClick: onClick
    }, filterCount > 0 && React__default.createElement(Badge, null, filterCount), filterCount > 0 ? "Filters" : "Add Filters"));
};
SearchFilter.dataId = "data-hpy-web-search-filter";
SearchFilter.displayName = "SearchFilter";

export { SearchFilter };
